import { RootState } from '../reducers/rootReducer';

export const userSelector = (state: RootState) => {
	return state?.auth?.userInfo;
};

export const isAdminSelector = (state: RootState) => {
	return state?.auth?.isAdmin;
};

export const userTagsSelector = (state: RootState) => {
	return state?.auth?.tags;
};
